var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"wrapper"},[_c('input',{staticClass:"checkbox",class:_vm.value,attrs:{"type":"radio"},domProps:{"checked":_vm.isChecked,"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event.target.value)}}}),_c('span',{staticClass:"checkmark",class:_vm.value})])
}
var staticRenderFns = []

export { render, staticRenderFns }